module.exports = __webpack_public_path__ + "img/20210430_110031.b40f00bb.jpg";